import {formatBedsRange} from "../../../../utils/formatting/formatBedsRange";
import {formatMoveInLabel} from "../../../../utils/formatting/formatMoveInLabel";
import {formatPriceRange} from "../../../../utils/formatting/formatPriceRange";

const MIN_PRICE = 250;
const MAX_PRICE = 8000;

const initSearchFilters = (_: Element) => {
  handlePlaceSearch();
  handlePrice();
  handleBedrooms();
  handleBathrooms();
  handleMoveInDate();
  handleFurnished();
  handleReset();
};

const el = document.currentScript;
if (el) {
  initSearchFilters(el);
}

// TODO: move this into PlaceSearch.client.ts
function handlePlaceSearch() {
  const placeSearchLabel = document.getElementById("place-search-label") as HTMLButtonElement;
  const placeSearchInput = document.getElementById("place-search-input") as HTMLInputElement;

  // rotate the text in place search label
  const displayList = ["city", "borough", "neighbourhood", "postcode"];
  let displayIndex = 0;
  setInterval(() => {
    displayIndex = (displayIndex + 1) % displayList.length;
    placeSearchLabel.textContent = `Search by ${displayList[displayIndex]}`;
  }, 1500);

  // focus search input on click
  placeSearchLabel.addEventListener("click", () => {
    // need to delay, wait for popover to be opened
    setTimeout(() => {
      placeSearchInput.focus();
    }, 10);
  });

  // prevent input changes in the place search from triggering the search filters htmx request
  // this input is only meant for the autocomplete results
  placeSearchInput.addEventListener("change", (e) => {
    e.stopPropagation();
  });

  // prevent enter key from submitting the form, reloading the page
  placeSearchInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
    }
  });
}

function handlePrice() {
  const searchFilters = document.getElementById("search-filters") as HTMLFormElement;

  const clearPrice = document.getElementById("clear-price") as HTMLButtonElement;
  const minPriceInput = document.getElementById("min-price-input") as HTMLInputElement;
  const maxPriceInput = document.getElementById("max-price-input") as HTMLInputElement;
  const priceLabel = document.getElementById("price-label") as HTMLSpanElement;
  const slider1 = document.getElementById("price-slider-1") as HTMLInputElement;
  const slider2 = document.getElementById("price-slider-2") as HTMLInputElement;
  const slider1Hint = document.getElementById("price-slider-1-hint") as HTMLInputElement;
  const slider2Hint = document.getElementById("price-slider-2-hint") as HTMLInputElement;
  const minPriceInputHint = document.getElementById("min-price-input-hint") as HTMLInputElement;
  const maxPriceInputHint = document.getElementById("max-price-input-hint") as HTMLInputElement;

  // "Clear" button
  clearPrice.addEventListener("click", () => {
    if (minPriceInput.value === "" && maxPriceInput.value === "") {
      return;
    }
    minPriceInput.value = "";
    maxPriceInput.value = "";
    minPriceInputHint.value = "";
    maxPriceInputHint.value = "";
    slider1.value = MIN_PRICE.toString();
    slider2.value = MAX_PRICE.toString();
    slider1Hint.value = MIN_PRICE.toString();
    slider2Hint.value = MAX_PRICE.toString();
    searchFilters.dispatchEvent(new Event("change"));
    priceLabel.textContent = formatPriceRange();
  });

  // Handle input box changes
  minPriceInput.addEventListener("change", () => {
    const min = minPriceInput.value === "" ? undefined : Number(minPriceInput.value);
    const max = maxPriceInput.value === "" ? undefined : Number(maxPriceInput.value);
    minPriceInputHint.value = min?.toString() ?? "";
    slider1.value = min?.toString() ?? MIN_PRICE.toString();
    slider1Hint.value = min?.toString() ?? MIN_PRICE.toString();
    priceLabel.textContent = formatPriceRange(min, max, "pounds", "compact");
  });
  maxPriceInput.addEventListener("change", () => {
    const min = minPriceInput.value === "" ? undefined : Number(minPriceInput.value);
    const max = maxPriceInput.value === "" ? undefined : Number(maxPriceInput.value);
    maxPriceInputHint.value = max?.toString() ?? "";
    slider2.value = max?.toString() ?? MAX_PRICE.toString();
    slider2Hint.value = max?.toString() ?? MAX_PRICE.toString();
    priceLabel.textContent = formatPriceRange(min, max, "pounds", "compact");
  });
  minPriceInputHint.addEventListener("change", () => {
    const min = minPriceInputHint.value === "" ? undefined : Number(minPriceInputHint.value);
    const max = maxPriceInputHint.value === "" ? undefined : Number(maxPriceInputHint.value);
    minPriceInput.value = min?.toString() ?? "";
    slider1.value = min?.toString() ?? MIN_PRICE.toString();
    slider1Hint.value = min?.toString() ?? MIN_PRICE.toString();
    priceLabel.textContent = formatPriceRange(min, max, "pounds", "compact");
  });
  maxPriceInputHint.addEventListener("change", () => {
    const min = minPriceInputHint.value === "" ? undefined : Number(minPriceInputHint.value);
    const max = maxPriceInputHint.value === "" ? undefined : Number(maxPriceInputHint.value);
    maxPriceInput.value = max?.toString() ?? "";
    slider2.value = max?.toString() ?? MAX_PRICE.toString();
    slider2Hint.value = max?.toString() ?? MAX_PRICE.toString();
    priceLabel.textContent = formatPriceRange(min, max, "pounds", "compact");
  });

  // Handle slider changes
  // Input events are triggered while the user is dragging the slider
  // We only update the input box so the user can see the current value
  slider1.addEventListener("input", (e) => {
    e.stopPropagation();
    let min: number | undefined = Number(slider1.value);
    if (min <= MIN_PRICE) {
      min = undefined;
    }
    minPriceInput.value = min?.toString() ?? "";
  });
  slider2.addEventListener("input", (e) => {
    e.stopPropagation();
    let max: number | undefined = Number(slider2.value);
    if (max >= MAX_PRICE) {
      max = undefined;
    }
    maxPriceInput.value = max?.toString() ?? "";
  });
  slider1Hint.addEventListener("input", (e) => {
    e.stopPropagation();
    let min: number | undefined = Number(slider1Hint.value);
    if (min <= MIN_PRICE) {
      min = undefined;
    }
    minPriceInputHint.value = min?.toString() ?? "";
  });
  slider2Hint.addEventListener("input", (e) => {
    e.stopPropagation();
    let max: number | undefined = Number(slider2Hint.value);
    if (max >= MAX_PRICE) {
      max = undefined;
    }
    maxPriceInputHint.value = max?.toString() ?? "";
  });

  // Change events are triggered when the user lets go of the slider
  // We rearrange the sliders so that slider1 is always the lower value.
  // Then we sync the input boxes and label to the new slider values.
  slider1.addEventListener("change", (e) => {
    e.stopPropagation();
    let min: number | undefined = Number(slider1.value);
    let max = maxPriceInput.value === "" ? undefined : Number(maxPriceInput.value);
    if (!!min && !!max && min > max) {
      const tmp = min;
      min = max;
      max = tmp;
    }
    if (min <= MIN_PRICE) {
      min = undefined;
    }
    slider1.value = min?.toString() ?? MIN_PRICE.toString();
    slider2.value = max?.toString() ?? MAX_PRICE.toString();
    slider1Hint.value = min?.toString() ?? MIN_PRICE.toString();
    slider2Hint.value = max?.toString() ?? MAX_PRICE.toString();
    minPriceInput.value = min?.toString() ?? "";
    maxPriceInput.value = max?.toString() ?? "";
    minPriceInputHint.value = min?.toString() ?? "";
    maxPriceInputHint.value = max?.toString() ?? "";
    priceLabel.textContent = formatPriceRange(min, max, "pounds", "compact");
    searchFilters.dispatchEvent(new Event("change"));
  });
  slider1Hint.addEventListener("change", (e) => {
    e.stopPropagation();
    let min: number | undefined = Number(slider1Hint.value);
    let max = maxPriceInput.value === "" ? undefined : Number(maxPriceInput.value);
    if (!!min && !!max && min > max) {
      const tmp = min;
      min = max;
      max = tmp;
    }
    if (min <= MIN_PRICE) {
      min = undefined;
    }
    slider1.value = min?.toString() ?? MIN_PRICE.toString();
    slider2.value = max?.toString() ?? MAX_PRICE.toString();
    slider1Hint.value = min?.toString() ?? MIN_PRICE.toString();
    slider2Hint.value = max?.toString() ?? MAX_PRICE.toString();
    minPriceInput.value = min?.toString() ?? "";
    maxPriceInput.value = max?.toString() ?? "";
    minPriceInputHint.value = min?.toString() ?? "";
    maxPriceInputHint.value = max?.toString() ?? "";
    priceLabel.textContent = formatPriceRange(min, max, "pounds", "compact");
    searchFilters.dispatchEvent(new Event("change"));
  });
  slider2.addEventListener("change", (e) => {
    e.stopPropagation();
    let max: number | undefined = Number(slider2.value);
    let min = minPriceInput.value === "" ? undefined : Number(minPriceInput.value);
    if (!!min && !!max && max < min) {
      const tmp = max;
      max = min;
      min = tmp;
    }
    if (max >= MAX_PRICE) {
      max = undefined;
    }
    slider1.value = min?.toString() ?? MIN_PRICE.toString();
    slider2.value = max?.toString() ?? MAX_PRICE.toString();
    slider1Hint.value = min?.toString() ?? MIN_PRICE.toString();
    slider2Hint.value = max?.toString() ?? MAX_PRICE.toString();
    minPriceInput.value = min?.toString() ?? "";
    maxPriceInput.value = max?.toString() ?? "";
    minPriceInputHint.value = min?.toString() ?? "";
    maxPriceInputHint.value = max?.toString() ?? "";
    priceLabel.textContent = formatPriceRange(min, max, "pounds", "compact");
    searchFilters.dispatchEvent(new Event("change"));
  });
  slider2Hint.addEventListener("change", (e) => {
    e.stopPropagation();
    let max: number | undefined = Number(slider2Hint.value);
    let min = minPriceInput.value === "" ? undefined : Number(minPriceInput.value);
    if (!!min && !!max && max < min) {
      const tmp = max;
      max = min;
      min = tmp;
    }
    if (max >= MAX_PRICE) {
      max = undefined;
    }
    slider1.value = min?.toString() ?? MIN_PRICE.toString();
    slider2.value = max?.toString() ?? MAX_PRICE.toString();
    slider1Hint.value = min?.toString() ?? MIN_PRICE.toString();
    slider2Hint.value = max?.toString() ?? MAX_PRICE.toString();
    minPriceInput.value = min?.toString() ?? "";
    maxPriceInput.value = max?.toString() ?? "";
    minPriceInputHint.value = min?.toString() ?? "";
    maxPriceInputHint.value = max?.toString() ?? "";
    priceLabel.textContent = formatPriceRange(min, max, "pounds", "compact");
    searchFilters.dispatchEvent(new Event("change"));
  });
}

function handleBedrooms() {
  const searchFilters = document.getElementById("search-filters") as HTMLFormElement;

  const clearBedrooms = document.getElementById("clear-bedrooms") as HTMLButtonElement;
  const minBedrooms = document.getElementById("min-bedrooms") as HTMLSelectElement;
  const maxBedrooms = document.getElementById("max-bedrooms") as HTMLSelectElement;
  const minBedroomsHint = document.getElementById("min-bedrooms-hint") as HTMLSelectElement;
  const maxBedroomsHint = document.getElementById("max-bedrooms-hint") as HTMLSelectElement;
  const bedroomsLabel = document.getElementById("bedrooms-label") as HTMLSpanElement;

  // "Clear" button
  clearBedrooms.addEventListener("click", () => {
    if (minBedrooms.value === "" && maxBedrooms.value === "") {
      return;
    }
    minBedrooms.value = "";
    maxBedrooms.value = "";
    minBedroomsHint.value = "";
    maxBedroomsHint.value = "";
    searchFilters.dispatchEvent(new Event("change"));
    bedroomsLabel.textContent = formatBedsRange();
  });

  // swap min and max if needed
  const swapMinMax = () => {
    const minBeds = minBedrooms.value === "" ? undefined : Number(minBedrooms.value);
    const maxBeds = maxBedrooms.value === "" ? undefined : Number(maxBedrooms.value);
    if (minBeds !== undefined && maxBeds !== undefined && minBeds > maxBeds) {
      minBedrooms.value = maxBeds.toString();
      maxBedrooms.value = minBeds.toString();
      minBedroomsHint.value = maxBeds.toString();
      maxBedroomsHint.value = minBeds.toString();
      bedroomsLabel.textContent = formatBedsRange(maxBeds, minBeds);
    }
  };

  // update label with new value
  minBedrooms.addEventListener("change", () => {
    const minBeds = minBedrooms.value === "" ? undefined : Number(minBedrooms.value);
    const maxBeds = maxBedrooms.value === "" ? undefined : Number(maxBedrooms.value);
    bedroomsLabel.textContent = formatBedsRange(minBeds, maxBeds);
    minBedroomsHint.value = minBeds?.toString() ?? "";
    swapMinMax();
  });
  maxBedrooms.addEventListener("change", () => {
    const minBeds = minBedrooms.value === "" ? undefined : Number(minBedrooms.value);
    const maxBeds = maxBedrooms.value === "" ? undefined : Number(maxBedrooms.value);
    bedroomsLabel.textContent = formatBedsRange(minBeds, maxBeds);
    maxBedroomsHint.value = maxBeds?.toString() ?? "";
    swapMinMax();
  });
  minBedroomsHint.addEventListener("change", () => {
    const minBeds = minBedroomsHint.value === "" ? undefined : Number(minBedroomsHint.value);
    const maxBeds = maxBedrooms.value === "" ? undefined : Number(maxBedrooms.value);
    bedroomsLabel.textContent = formatBedsRange(minBeds, maxBeds);
    minBedrooms.value = minBeds?.toString() ?? "";
    swapMinMax();
  });
  maxBedroomsHint.addEventListener("change", () => {
    const minBeds = minBedrooms.value === "" ? undefined : Number(minBedrooms.value);
    const maxBeds = maxBedroomsHint.value === "" ? undefined : Number(maxBedroomsHint.value);
    bedroomsLabel.textContent = formatBedsRange(minBeds, maxBeds);
    maxBedrooms.value = maxBeds?.toString() ?? "";
    swapMinMax();
  });
}

function handleBathrooms() {
  const minBathrooms = document.getElementById("min-bathrooms") as HTMLSelectElement;
  const maxBathrooms = document.getElementById("max-bathrooms") as HTMLSelectElement;

  const swapMinMax = () => {
    const minBaths = minBathrooms.value === "" ? undefined : Number(minBathrooms.value);
    const maxBaths = maxBathrooms.value === "" ? undefined : Number(maxBathrooms.value);
    if (minBaths !== undefined && maxBaths !== undefined && minBaths > maxBaths) {
      minBathrooms.value = maxBaths.toString();
      maxBathrooms.value = minBaths.toString();
    }
  };

  minBathrooms.addEventListener("change", swapMinMax);
  maxBathrooms.addEventListener("change", swapMinMax);
}

function handleMoveInDate() {
  const searchFilters = document.getElementById("search-filters") as HTMLFormElement;
  const clearTargetMoveIn = document.getElementById("clear-targetMoveIn") as HTMLButtonElement;
  const targetMoveIn = document.getElementById("target-move-in") as HTMLInputElement;
  const targetMoveInHint = document.getElementById("target-move-in-hint") as HTMLInputElement;
  const targetMoveInLabel = document.getElementById("target-move-in-label") as HTMLSpanElement;

  // "Clear" button
  clearTargetMoveIn.addEventListener("click", () => {
    if (targetMoveIn.value === "") {
      return;
    }
    targetMoveIn.value = "";
    targetMoveInHint.value = "";
    searchFilters.dispatchEvent(new Event("change"));
    targetMoveInLabel.textContent = formatMoveInLabel();
  });

  // update label with new value
  targetMoveIn.addEventListener("change", () => {
    const date = targetMoveIn.value === "" ? undefined : new Date(targetMoveIn.value);
    targetMoveInLabel.textContent = formatMoveInLabel(date);
    targetMoveInHint.value = date?.toISOString().split("T")[0] ?? "";
  });
  targetMoveInHint.addEventListener("change", () => {
    const date = targetMoveInHint.value === "" ? undefined : new Date(targetMoveInHint.value);
    targetMoveInLabel.textContent = formatMoveInLabel(date);
    targetMoveIn.value = date?.toISOString().split("T")[0] ?? "";
  });
}

function handleFurnished() {
  const furnished = document.getElementById("furnished-input") as HTMLInputElement;
  const unfurnished = document.getElementById("unfurnished-input") as HTMLInputElement;

  furnished.addEventListener("change", () => {
    if (furnished.checked) {
      unfurnished.checked = false;
    }
  });

  unfurnished.addEventListener("change", () => {
    if (unfurnished.checked) {
      furnished.checked = false;
    }
  });
}

function handleReset() {
  const resetButton = document.getElementById("reset-button") as HTMLButtonElement;
  const searchFilters = document.getElementById("search-filters") as HTMLFormElement;
  resetButton.addEventListener("click", () => {
    Array.from(searchFilters.elements).forEach((el) => {
      if (el.tagName === "INPUT") {
        const input = el as HTMLInputElement;
        if (input.type === "checkbox" || input.type === "radio") {
          input.checked = false;
        } else {
          input.value = "";
        }
      }

      if (el.tagName === "SELECT") {
        (el as HTMLSelectElement).selectedIndex = 0;
      }
    });

    resetPriceSliders();
    resetFilterLabels();
    searchFilters.dispatchEvent(new Event("change"));
  });
}

function resetPriceSliders() {
  const minSliders = [
    document.getElementById("price-slider-1") as HTMLInputElement,
    document.getElementById("price-slider-1-hint") as HTMLInputElement,
  ];
  const maxSliders = [
    document.getElementById("price-slider-2") as HTMLInputElement,
    document.getElementById("price-slider-2-hint") as HTMLInputElement,
  ];

  minSliders.forEach((slider) => {
    slider.value = MIN_PRICE.toString();
  });
  maxSliders.forEach((slider) => {
    slider.value = MAX_PRICE.toString();
  });
}

function resetFilterLabels() {
  const priceLabel = document.getElementById("price-label") as HTMLSpanElement;
  const bedroomsLabel = document.getElementById("bedrooms-label") as HTMLSpanElement;
  const targetMoveInLabel = document.getElementById("target-move-in-label") as HTMLSpanElement;

  priceLabel.textContent = formatPriceRange();
  bedroomsLabel.textContent = formatBedsRange();
  targetMoveInLabel.textContent = formatMoveInLabel();
}
